import React from 'react';
import { Flex } from '@components/Flex';
import { Box } from '@components/Box';
import { babyRegistryPageData } from '@data-ts/pages/baby-registry';
import { ShopRegistryDepartment } from './ShopRegistryDepartment';
import { SECTION_ID, VENDOR_IMAGES, SLIDE_SPEED, DEPARTMENTS_ELEMENT_ID, BRANDS_ELEMENT_ID } from './ShopRegistrySection.constants';
import { Vendors, StyledText, StyledBox } from './ShopRegistrySection.styles';
import { InfiniteSlider } from '@components/InfiniteSlider';
import { HorizontalSlider } from '@sections/shared/HorizontalSlider';
import { getRootUrl } from '@utils/urlHelpers.util';

const { shopRegistry } = babyRegistryPageData;

export const ShopRegistrySection: React.FC = () => {
  return (
    <Box as="section" id={SECTION_ID} marginTop={[7, 0]}>
      <Vendors paddingY={[7, 9]}>
        <Flex justifyContent="center" marginBottom={[5, 7]} paddingTop={[0, 3]}>
          <StyledText color="neutra5" variant="dek20" tagName="h3">
            {shopRegistry.subTitle}
          </StyledText>
        </Flex>
        <StyledBox paddingBottom={[0, 3]}>
          <InfiniteSlider
            scrollName="baby-registry-brands"
            elementId={BRANDS_ELEMENT_ID}
            stopOnHover
            images={VENDOR_IMAGES}
            speed={SLIDE_SPEED}
            gap={{ sm: 72, belowSm: 45 }}
            scale={{ belowSm: 1, sm: 0.8, lg: 1, xl: 1.2 }}
          />
        </StyledBox>
      </Vendors>
      <Box marginTop={9} paddingTop={[0, 3]}>
        <HorizontalSlider
          title={shopRegistry.shopTitle}
          items={[
            {
              id: 'DepartmentClothing',
              item: (
                <ShopRegistryDepartment
                  title="Clothing"
                  elementId={DEPARTMENTS_ELEMENT_ID}
                  image="baby-registry/departments/clothing-v3.png"
                  link={getRootUrl(`/shop/baby/catalog/clothing`)}
                />
              ),
            },
            {
              id: 'DepartmentStrollersAndSeats',
              item: (
                <ShopRegistryDepartment
                  title="Strollers & Car Seats"
                  elementId={DEPARTMENTS_ELEMENT_ID}
                  image="baby-registry/departments/strollers-v4.png"
                  link={getRootUrl(`/shop/baby/catalog/strollers-car-seats`)}
                />
              ),
            },
            {
              id: 'DepartmentTravelAndGear',
              item: (
                <ShopRegistryDepartment
                  title="Travel & Gear"
                  elementId={DEPARTMENTS_ELEMENT_ID}
                  image="baby-registry/departments/travel-v3.png"
                  link={getRootUrl(`/shop/baby/catalog/travel-gear`)}
                />
              ),
            },
            {
              id: 'DepartmentFeedingAndNursing',
              item: (
                <ShopRegistryDepartment
                  title="Feeding & Nursing"
                  elementId={DEPARTMENTS_ELEMENT_ID}
                  image="baby-registry/departments/feeding-v3.png"
                  link={getRootUrl(`/shop/baby/catalog/feeding-nursing`)}
                />
              ),
            },
            {
              id: 'DepartmentNursery',
              item: (
                <ShopRegistryDepartment
                  title="Nursery"
                  elementId={DEPARTMENTS_ELEMENT_ID}
                  image="baby-registry/departments/nursery-v3.png"
                  link={getRootUrl(`/shop/baby/catalog/nursery`)}
                />
              ),
            },
            {
              id: 'DepartmentBathAndPotty',
              item: (
                <ShopRegistryDepartment
                  title="Bath & Potty"
                  elementId={DEPARTMENTS_ELEMENT_ID}
                  image="baby-registry/departments/bath-v3.png"
                  link={getRootUrl(`/shop/baby/catalog/bath-potty`)}
                />
              ),
            },
            {
              id: 'DepartmentToysAndActivities',
              item: (
                <ShopRegistryDepartment
                  title="Toys & Activities"
                  elementId={DEPARTMENTS_ELEMENT_ID}
                  image="baby-registry/departments/toys-v3.png"
                  link={getRootUrl(`/shop/baby/catalog/toys-activity`)}
                />
              ),
            },
            {
              id: 'DepartmentHealthAndSafety',
              item: (
                <ShopRegistryDepartment
                  title="Health & Safety"
                  elementId={DEPARTMENTS_ELEMENT_ID}
                  image="baby-registry/departments/health-v3.png"
                  link={getRootUrl(`/shop/baby/catalog/health-safety`)}
                />
              ),
            },
            {
              id: 'DepartmentCashAndExperience',
              item: (
                <ShopRegistryDepartment
                  title="Cash & Experience"
                  elementId={DEPARTMENTS_ELEMENT_ID}
                  image="baby-registry/departments/cash-v4.png"
                  link={getRootUrl(`/shop/baby/catalog/cash-experiences`)}
                />
              ),
            },
          ]}
        />
      </Box>
    </Box>
  );
};
